// deps
import React, { memo, ReactElement, useMemo } from "react";

// internal deps
import { AriaHidden, format, isEmpty, useEffectOnce } from "@swiggy-private/core-ui";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

// widgets
import { ArrowSvgIcon } from "@payment-ui/widgets/arrow-svg-icon";

// styles
import {
    ArrowIcon,
    ArrowIconWrapper,
    Banner,
    BannerContentContainer,
    Carousel,
    CarouselIcon,
    CarouselImg,
    CarouselStaticItem,
    Wrapper,
} from "./styles/OffersStrip.styled";

//helpers
import { getCloudinaryUrl } from "@swiggy-private/core-ui";

//interface
import { OffersStripBodys } from "@payment-ui/interfaces";
import { OFFER_STRIP_TEST_IDS } from "@swiggy-private/payment-test-ids";

const OFFER_TEXT = 'Save <span style="font-weight: 600;">upto ₹{0}</span> more with payment offers';
const OFFERS_TEXT_PLAIN = "Save more with payment offers";
const ARROW_COLOR = "green";
const staticIcon = "v1685605082/Ratnesh_Badges/Icon_for_offer.png";

interface IOfferIcons {
    offerIcons?: string[];
}

function OfferIcon(_props: IOfferIcons): ReactElement {
    return (
        <Wrapper aria-hidden="true">
            <Carousel>
                <CarouselStaticItem>
                    <CarouselIcon>
                        <CarouselImg
                            crossOrigin="anonymous"
                            src={getCloudinaryUrl(staticIcon)}
                            data-testId={OFFER_STRIP_TEST_IDS.STATIC_IMAGE}
                        />
                    </CarouselIcon>
                </CarouselStaticItem>
            </Carousel>
        </Wrapper>
    );
}

function OffersStrip(props: OffersStripBodys): ReactElement {
    const isDiscountPresent = !isEmpty(props.maxDiscount) && props.maxDiscount !== "0";
    const text = isDiscountPresent ? format(OFFER_TEXT, props.maxDiscount) : OFFERS_TEXT_PLAIN;

    useEffectOnce(() => {
        props.impressionEvent(text);
    });

    const offerIcons = useMemo(() => {
        return <OfferIcon offerIcons={props.icons} />;
    }, [props.icons]);

    return (
        <Banner data-testId={OFFER_STRIP_TEST_IDS.CONTAINER} onClick={props.goToOffersPage}>
            <BannerContentContainer>
                {offerIcons}
                <Text
                    variant="V2.body2.neutral.medium"
                    color="positive"
                    data-testId={OFFER_STRIP_TEST_IDS.TEXT}
                    dangerouslySetInnerHTML={{ __html: text }}
                />
            </BannerContentContainer>
            <AriaHidden as="div">
                <ArrowIconWrapper>
                    <ArrowIcon as={ArrowSvgIcon} color={ARROW_COLOR} />
                </ArrowIconWrapper>
            </AriaHidden>
        </Banner>
    );
}

export default memo(OffersStrip);
